export function getCanonicalUrl(pathname) {
  const base =
    process.env.REACT_APP_BASE_DOMAIN ||
    (typeof window !== 'undefined' ? window.location.origin : '');
  return `${base}${pathname}`;
}
